import { applyMiddleware, compose, createStore, StoreEnhancer } from 'redux'
import thunkMiddleware from 'redux-thunk'

import rootReducer from './index'

export default function configureStore(preloadedState?: any) {
  const middlewares = [thunkMiddleware]
  const middlewareEnhancer = applyMiddleware(...middlewares)

  const enhancers = [middlewareEnhancer]
  const composedEnhancers : StoreEnhancer<unknown, {}> = compose(...enhancers)

  const store = createStore(rootReducer, preloadedState, composedEnhancers)

  return store
}
